import { useEffect } from "react";

import { SelectedSearchResult } from "@/states/common/venueAndTaskAndUserSearch/selectedSearchResultAtom";
import { ApplyFilter } from "@/types/owner/task/applyFilter";

type Props = {
  searchType: "contract" | "venue";
  word: string;
  keyDownEnter: boolean;
  filterList: any;
  setShowList: React.Dispatch<React.SetStateAction<boolean>>;
  setSearched: React.Dispatch<React.SetStateAction<boolean>>;
  setKeyDownEnter: React.Dispatch<React.SetStateAction<boolean>>;
  setSearchWord: React.Dispatch<React.SetStateAction<SelectedSearchResult>>;
  setContractSearchWord: React.Dispatch<
    React.SetStateAction<SelectedSearchResult>
  >;
  setFilterList?: React.Dispatch<React.SetStateAction<any>>;
  setApplyFilter?: React.Dispatch<React.SetStateAction<ApplyFilter>>;
};

//検索ワードから取得した物件情報をセット
export const useSearchResultSelect = ({
  keyDownEnter,
  searchType,
  word,
  filterList,
  setShowList,
  setSearched,
  setKeyDownEnter,
  setSearchWord,
  setContractSearchWord,
  setFilterList,
  setApplyFilter
}: Props) => {
  useEffect(() => {
    //Enterキー押下時に検索実行
    if (keyDownEnter) {
      if (setFilterList) {
        setFilterList({
          ...filterList,
          page: 1,
          venueId: null,
          q: word,
          cat_search: 0,
          equal: 0
        });
      }
      setShowList(false);
      setSearched(true);
      setKeyDownEnter(false);
      if (setApplyFilter) setApplyFilter("normal");
      const searchWordArr = {
        word: word,
        activeType: ""
      };
      if (searchType === "venue") {
        setSearchWord(searchWordArr);
      } else {
        setContractSearchWord(searchWordArr);
      }
    }
  }, [keyDownEnter]);
};
